import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import {
  getUnderlyingLiveFeed,
  getUnderlyingLiveFeedClosePrices,
} from '../../../../stores/underlying-live-feed/getters';
import PlusMinusColoredValue from '../../../PlusMinusColoredValue';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '13.3px',
    display: 'inline-flex',
    marginLeft: 5,

    [theme.breakpoints.up('md')]: {
      fontSize: 12,
    },
  },
}));

function calculatePriceDiffrence(ltpPrice, closePrice) {
  if (!ltpPrice && ltpPrice !== 0) {
    return 0;
  }

  if (!closePrice) {
    return 0;
  }

  const diffrence = ((ltpPrice - closePrice) / closePrice) * 100;

  return diffrence;
}

const PriceDiffrence = ({ symbol }) => {
  const classes = useStyles();
  const ltp = useSelector((state) => {
    const value = getUnderlyingLiveFeed(state);

    const { ltp } = value[symbol] ? value[symbol] : {};

    return ltp;
  });

  const closePrice = useSelector((state) => {
    const value = getUnderlyingLiveFeedClosePrices(state);

    const { ltp } = value[symbol] ? value[symbol] : {};

    return ltp;
  });

  const diffrence = calculatePriceDiffrence(ltp, closePrice);

  if (!diffrence) {
    return <></>;
  }

  return (
    <PlusMinusColoredValue
      className={`${classes.root} PriceDiffrencePercentage`}
      value={diffrence}
    >
      ({diffrence.toFixed(2)}%)
    </PlusMinusColoredValue>
  );
};

export default PriceDiffrence;
